import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {ApolloProvider} from "@apollo/client";
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import client from "./apolloClient";
import theme from "./theme";

import SidebarLayout from "./components/Sidebar";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import ActivateAccount from "./pages/ActivateAccount";
import Customer from "./pages/Customer";
import Forbidden from "./pages/Forbidden";
import NotFound from "./pages/NotFound";
import Users from "./pages/Users";
import Resellers from "./pages/Resellers";
import ResellerUsers from "./pages/ResellerUsers";
import CustomerUsers from "./pages/CustomerUsers";
import {LoadScript} from "@react-google-maps/api";
import Locations from "./pages/Locations";
import Akiferra from "./pages/Akiferra";
import Makmini from "./pages/Makmini";
import MakminiStatistic from "./pages/MakminiStatistic";
import AkiferraStatistic from "./pages/AkiferraStatistic";
import MakminiTelemetry from "./pages/MakminiTelemetry";
import AkiferraTelemetry from "./pages/AkiferraTelemetry";
import Alarm from "./pages/Alarm";
import Dashboard from "./pages/Dashboard";
import MapPage from "./pages/MapPage";


const libraries = ["places"];

export default function App() {
    return (
        <ApolloProvider client={client}>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <LoadScript googleMapsApiKey="AIzaSyCNQlicydON-_g4zJgROSzg0qqr7fk4Flw" libraries={libraries}>
                    <BrowserRouter>
                        <Routes>

                            <Route path="*" element={<NotFound/>}/>

                            <Route path="/" element={<Login/>}/>
                            <Route path="/activate" element={<ActivateAccount/>}/>
                            <Route path="/403" element={<Forbidden/>}/>

                            <Route
                                path="/app"
                                element={
                                    <ProtectedRoute allowedRoles={["ADMIN", "RESELLER", "CUSTOMER"]}>
                                        <SidebarLayout/>
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<Navigate to="dashboard" replace/>}/>

                                <Route path="dashboard" element={<Dashboard/>}/>
                                <Route path="map" element={<MapPage/>}/>

                                <Route
                                    path="users"
                                    element={
                                        <ProtectedRoute allowedRoles={["ADMIN"]}>
                                            <Users/>
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="resellerusers"
                                    element={
                                        <ProtectedRoute allowedRoles={["ADMIN", "RESELLER"]}>
                                            <ResellerUsers/>
                                        </ProtectedRoute>
                                    }
                                />
                                <Route path="customerusers" element={<CustomerUsers/>}/>
                                <Route
                                    path="customer"
                                    element={
                                        <ProtectedRoute allowedRoles={["ADMIN", "RESELLER"]}>
                                            <Customer/>
                                        </ProtectedRoute>
                                    }
                                />

                                <Route
                                    path="reseller"
                                    element={
                                        <ProtectedRoute allowedRoles={["ADMIN"]}>
                                            <Resellers/>
                                        </ProtectedRoute>
                                    }
                                />

                                <Route path="locations" element={<Locations/>}/>

                                <Route path="makmini" element={<Makmini/>}/>
                                <Route path="akiferra" element={<Akiferra/>}/>
                                <Route path="alarm" element={<Alarm/>}/>
                                <Route path="makministatistics" element={<MakminiStatistic/>}/>
                                <Route path="akiferrastatistics" element={<AkiferraStatistic/>}/>
                                <Route path="akiferratelemetry" element={<AkiferraTelemetry/>}/>
                                <Route path="makminitelemetry" element={<MakminiTelemetry/>}/>
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </LoadScript>
            </ThemeProvider>
        </ApolloProvider>
    );
}
